var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Box',_vm._b({},'Box',_vm.$attrs,false),[_c('Box',{staticClass:"nav",attrs:{"tag":"nav","paddingX":_vm.headerPaddingX,"paddingY":_vm.headerPaddingY}},[_c('Box',{staticClass:"inner-nav",attrs:{"display":"flex"}},[_vm._t("nav")],2)],1),_c('Box',{attrs:{"tag":"main"}},[_vm._t("body")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }